import { useBusinessEntity } from '@commenda/api';
import {
  CountryCode,
  FullscreenModal,
  FullscreenModalContent,
} from '@commenda/kakashi';
import { IncorporationFormHeader } from '../../form-builder/components/new-incorp-layout';
import { EditShareClassesForm } from './forms/EditShareClassesForm';

interface EditShareClassesPageProps {
  corporationId: number;
  onClose: () => void;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
}

export const EditShareClassesPage = ({
  corporationId,
  onClose,
  onSuccess,
  onError,
}: EditShareClassesPageProps) => {
  const { data: businessEntity } = useBusinessEntity(corporationId);
  const entityName = businessEntity?.generalCorporationInfo?.legalName ?? '';
  const entityCountry =
    businessEntity?.generalCorporationInfo?.incorporationCountry;

  return (
    <FullscreenModal isOpen onClose={onClose} enableEscapeKey>
      <IncorporationFormHeader
        entity={
          entityName && entityCountry
            ? { name: entityName, countryCode: entityCountry as CountryCode }
            : undefined
        }
        onClose={onClose}
      />

      <FullscreenModalContent className="bg-bg-light flex justify-center overflow-y-auto">
        <div className="flex w-[640px] max-w-full flex-col gap-2xl py-4xl">
          <EditShareClassesForm
            corporationId={corporationId}
            onCancel={onClose}
            onSuccess={onSuccess}
            onError={onError}
          />
        </div>
      </FullscreenModalContent>
    </FullscreenModal>
  );
};
